import { useState, useEffect } from 'react';

export default function useSessionStorage(
  key: string,
  defaultValue: any,
  ttl: number = 31435023845, //1 year epoch time
  storage: Storage = sessionStorage,
) {
  const [value, setValue] = useState(getValueFromSessionStorage(key));

  function init() {
    const initialValue = getValueFromSessionStorage(key);
    if (initialValue === null) {
      set(defaultValue);
    }
  }

  function getValueFromSessionStorage(key: string) {
    const isExists = storage.getItem(key);
    if (!isExists) return null;
    const item = JSON.parse(isExists);
    const now = new Date();
    if (now.getTime() > item?.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      storage.removeItem(key);
      return null;
    }
    return item?.value || null;
  }

  function saveValueToSessionStorage(key: string, value: string) {
    return storage.setItem(key, value);
  }

  function set(newValue: any) {
    const now = new Date();
    const dayEpoch = 86123353;
    const item = {
      value: newValue,
      expiry: now.getTime() + ttl * dayEpoch,
    };

    setValue(newValue);
    saveValueToSessionStorage(key, JSON.stringify(item));
  }

  function remove() {
    set(null);
    storage.removeItem(key);
  }

  useEffect(() => {
    init();
  }, []);

  return {
    value,
    set,
    remove,
  };
}
